/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApiRootResource, LoeschOrganisationEinheit } from '../api-root.model';
import { API_ROOT_FEATURE_KEY, ApiRootState } from './api-root.reducer';

const getApiRootState = createFeatureSelector<ApiRootState>(API_ROOT_FEATURE_KEY);

const apiRoot = createSelector(getApiRootState, (state: ApiRootState) => state.apiRoot);

const loeschOrganisationEinheit = createSelector(
  apiRoot,
  (apiRootStateResource: StateResource<ApiRootResource>): LoeschOrganisationEinheit | undefined =>
    apiRootStateResource.resource?.loeschOrganisationEinheit,
);

export const ApiRootSelectors = {
  apiRoot,
  loeschOrganisationEinheit,
};
